// Constants
export const COURIER_LOADING = 'COURIER_LOADING';
export const COURIERS_FULFILLED = 'COURIERS_FULFILLED';
